import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Link from 'next/link';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Wrapper from '@/components/wrapper';
import request from '@/utils/request';
import classNames from 'classnames';
import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";

interface IProps {

}

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data } = await request.get(`/api/get_exhibitor_comments`)
  return {
    props: {
      ...res.props,
      data: data?.data || null
    }
  }
}

const Comment: NextPage<IProps> = ({ menuDetail, data }: any) => {
  const router = useRouter();
  const t = useTranslations("exhibition.comment");

  const chunkArray = (arr: any, chunkSize: number) => {
    const chunkedArray = [];
    if (arr.length === chunkSize) return [arr]
    if (arr.length < chunkSize) return [arr]
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      const len = arr.slice(index, end).length
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }

  useEffect(() => {
    setTimeout(() => {
      const str = document.getElementById("reactCode")?.innerText || 'console.log()';
      eval(
        str
      )
    }, 0);
  }, [menuDetail]);

  return (
    <div>
      <Wrapper>
        <div className={classNames([styles.container, 'm-1600'])}>
          {getHead(menuDetail)}
          <h2>{t("section1.title")}</h2>
          <div dangerouslySetInnerHTML={{ __html: menuDetail?.info?.content }} />
          <div className={styles.audience}>
            <h2 style={{ paddingLeft: '30px' }}>{t("section2.title")}<span>{t("section2.subtitle")}</span></h2>
            <div className={styles.audiList}>
              <Swiper
                className='brand'
                slidesPerView={'auto'}
                spaceBetween={26}
                modules={[Autoplay, Pagination]}
                pagination={{ clickable: true }}
              >
                {
                  data.exhibitor_comments_list?.length
                  && chunkArray(data.exhibitor_comments_list, 21)?.map((item: any, index: number) => (
                    <SwiperSlide key={index}>
                      <div className={styles.logList}>
                        {
                          item.map((child: any, idx: number) => (
                            <Link key={idx} href={child[`link_${router.locale}`] ? child[`link_${router.locale}`] : "javascript:;"}>
                              <a target={child[`link_${router.locale}`] ? '_blank' : '_self'}>
                                <img src={child.image} alt={child[`title_${router.locale}`]} />
                              </a>
                            </Link>
                          ))
                        }
                      </div>
                    </SwiperSlide>
                  ))
                }
              </Swiper>
            </div>
          </div>
          <div className={styles.photo}>
            <h2>{t("section3.title")}</h2>
            <div className={styles.imgList}>
              {
                data.exhibition_atlas_list?.map((item: any, index: number) => (
                  <div key={index} className={styles.imgItem}>
                    <img src={item.photo} alt={item[`brief_${router.locale}`]} />
                  </div>
                ))
              }
            </div>
            <Link href="/media/photo">
              <a>
                <div className={classNames([styles.more, styles.btnStyle, 'btnStyle'])}>
                  <span>{t("section3.more")}</span>
                  {/* @ts-ignore */}
                  <svg t="1723196878237" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    p-id="2672" width="14" height="14">
                    <path d="M320 0 192 128l384 384-384 384 128 128 512-512L320 0z" p-id="2673" fill="#231F20">
                    </path>
                  </svg>
                </div>
              </a>
            </Link>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default Comment;
